import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step9({ nextStep, prevStep, updateFieldValue, value }) {

    const [name, setName] = useState(value)
    const [error, showError] = useState(false)

    const handleNextStep = () => {
        if (name === "" || !name || name.length === 0) {
            showError(true)
        } else {
            nextStep(9)
        }
    }


    return (
        <div id="step9" >
            <div className='max-w-lg mx-auto p-10'>
                <fieldset>
                    <legend className='font-normal text-base px-4 md:px-6'>May we have your <strong>last name</strong>?</legend>
                    <div className='mt-5 ml-2 text-base text-gray-800'>
                        <input
                            type="text"
                            name="lastname"
                            maxLength="100"
                            defaultValue={value}
                            onChange={(e) => {
                                updateFieldValue("lastName", e.target.value);
                                setName(e.target.value)
                            }}
                            className={`w-full h-12 rounded-md border font-semibold text-base transition-colors px-4
               ${error
                                    ? "border-red-600 bg-red-50"
                                    : "border-gray-400 bg-white"
                                }`}
                        />
                    </div>
                </fieldset>
                {
                    error &&
                    <p className="mt-2 mb-0 text-xs text-red-500 flex">
                        <XCircleIcon className="h-4 w-4 mr-1" /> Please enter a value.
                    </p>
                }
            </div>
            <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                <button
                    id="calcStep9Prev"
                    onClick={() => prevStep(9)}
                    className="flex items-center h-full w-fit rounded-bl-md hover:bg-blue-800 text-white text-base px-5 py-1.5 font-semibold uppercase">
                    <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                </button>

                {/* Centered Step Counter */}
                <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                    9 of 12
                </div>

                {/* Next Button */}
                <button
                    id="calcStep9Next"
                    onClick={() => handleNextStep()}
                    className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                >
                    <span className="hidden md:block">Next</span>
                    <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
            </div>

        </div>
    );
}